import { render, staticRenderFns } from "./IconMetro.vue?vue&type=template&id=94c1b814&"
import script from "./IconMetro.vue?vue&type=script&lang=js&"
export * from "./IconMetro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports